/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type ShipmentsTaskGroupsListTaskType = typeof ShipmentsTaskGroupsListTaskType[keyof typeof ShipmentsTaskGroupsListTaskType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsTaskGroupsListTaskType = {
  Sub_Task: 'Sub Task',
  Task: 'Task',
} as const;
